import { LiveAuction } from 'pages/Auction/LiveAuction'
import { Route, Switch, useRouteMatch } from 'react-router'
import { Auction } from '../pages/Auction'
import { Product } from '../pages/Auction/Product'

const AuctionRoutes = () => {
  let { path } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${path}/:auctionId/live`} exact>
        <LiveAuction />
      </Route>
      <Route path={`${path}/:auctionId`} exact>
        <Auction />
      </Route>
      <Route path={`${path}/:auctionId/:productId`} exact>
        <Product />
      </Route>
    </Switch>
  )
}

export default AuctionRoutes
